import React, { useEffect } from 'react'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import dayjs, { Dayjs } from 'dayjs'

import styles from './date.module.scss'

export const DateInput = ({
	setDate,
	label,
	date,
	prevdate,
}: {
	setDate: React.Dispatch<React.SetStateAction<string | undefined | Dayjs>>
	label?: string
	date?: boolean
	prevdate?: boolean
}) => {
	useEffect(() => {
		if (date) {
			setDate(dayjs().format('YYYY-MM-DD')) 
		}
		if (prevdate) {
			setDate(dayjs().add(-1, 'year').format('YYYY-MM-DD')) 
		}
	}, [date, prevdate])

	return (
		<LocalizationProvider dateAdapter={AdapterDayjs}>
			<DatePicker
				slotProps={{ toolbar: { hidden: true } }}
				sx={{
					backgroundColor: '#464646',
					svg: { color: '#7f7df3' },
					input: { color: '#d4d4d4' },
					borderRadius: '5px',
					marginTop: '8px',
					label: {
						color: '#7D7D7D',
					},
					width: '100%',
				}}
				label={label ? label : 'Дата'}
				value={date ? dayjs() : prevdate ? dayjs().add(-1, 'year') : null}
				onChange={(date) => {
					if (date?.isValid()) {
						setDate(date.format('YYYY-MM-DD')) 
					}
				}}
				format='MM-DD-YYYY'
				views={['year', 'month', 'day']}
			/>
		</LocalizationProvider>
	)
}
